module.exports = __webpack_public_path__ + "assets/img/sf2@2x.2befc9e0.png";